import IPortal from '../IPortal'
import { API } from 'aws-amplify'
import axios from 'axios'
import Qs from 'qs'

class PortalDataStoreAWS extends IPortal {

  // Assuming AXIOS is being used by Amplify library
  handleError(err, functionName) {
    if (err.response) {
      let text = `${err.message} ${JSON.stringify(err.response.data)}`
      console.log(`ERROR ${functionName} status: ${err.response.status}`)
      console.log(`ERROR ${functionName} data: ${JSON.stringify(err.response.data)}`)
      console.log(`ERROR ${functionName} headers: ${JSON.stringify(err.response.headers, null, 2)}`)
      let error = new Error(text)
      error.status = err.response.status
      error.statusText = err.response.statusText
      return error
    }
    console.log(`ERROR ${functionName} request: ${err.message}`)
    return err
  }
  
  putContent = async (content) => {
    try {
      const url = await API.get('portalCompany', '/portal/content/upload/signed-url', {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      await axios.put(url.data.uploadURL, content)
    }
    catch (err) {
      throw this.handleError(err, 'Portal putContent')
    }
  }

  getContent = async () => {
    try {
      const url = await API.get('portalCompany', `/portal/content/download/signed-url`, {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      const response = await axios.get(url.data.uploadURL)
      return response.data
    }
    catch (err) {
      if (err.response && err.response.status === 403) { // Returned forbidden when there is no content
        return "<p><br/></p>"
      }
      throw this.handleError(err, 'Portal getContent')
    }
  }

  getContentSample = async () => {
    try {
      const url = await API.get('portalCompany', `/portal/content-sample/download/signed-url`, {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      const response = await axios.get(url.data.uploadURL)
      return response.data
    }
    catch (err) {
      if (err.response && err.response.status === 403) { // Returned forbidden when there is no content
        return "<p><br/></p>"
      }
      throw this.handleError(err, 'Portal getContentSample')
    }
  }

  putPublishContent = async () => {
    try {
      await API.put('companies', '/companies/portal/content/publish/object', {
          response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (err) {
      throw this.handleError(err, 'Portal putPublishContent')
    }
  }

  putSection = async (name, content, order) => {
    try {
      await API.put('portalCompany', '/portal/section/object', {
          body: {
            section: { name, content, order}
          },
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
    }
    catch (err) {
      throw this.handleError(err, 'Portal putSection')
    }
  }

  getSection = async (section) => {
    try {
      const res = await API.get('portalCompany', `/portal/section/object/${section}`, {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.section) {
        return res.data.section
      } else {
        console.error(`Portal getSection GET getUploadURL data missing: ${JSON.stringify(res, null, 2)}`)
        throw new Error('Portal getSection GET downloadURL data missing')
      }
    }
    catch (err) {
      throw this.handleError(err, 'Portal getSection')
    }
  }

  getListSections = async () => {
    try {
      const res = await API.get('portalCompany', `/portal/section/list`, {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.sections) {
        return res.data.sections
      } else {
        console.error(`Portal getListSections GET getUploadURL data missing: ${JSON.stringify(res, null, 2)}`)
        throw new Error('Portal getListSections GET downloadURL data missing')
      }
    }
    catch (err) {
      throw this.handleError(err, 'Portal getListSections')
    }
  }

  getFileUploadURL = async (filename, options) => {
    try {
      const noParensFileName = filename.replace(/\(/g, '%28').replace(/\)/g, '%29')
      let separator = '?'
      let url = `/portal/file/upload/signed-url/${noParensFileName}`
      if (options && options.title) {
        url += `${separator}title=${options.title}`
        separator = '&'
      }
      if (options && options.contentType) {
        url += `${separator}ContentType=${options.contentType}`
        separator = '&'
      }

      const paramsSerializer = (prefix, value) => {
          const p = Qs.stringify(url, {
            filter: (prefix, value) => {
            const v = value.replace(/\(/g, '%28').replace(/\)/g, '%29')
            return v
          }
        }
        )
        return p
      }
      const res = await API.get('portalCompany', url, {
        paramsSerializer,
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.uploadURL) {
        return res.data.uploadURL
      } else {
        console.error(`getFileUploadURL GET data missing: ${JSON.stringify(res, null, 2)}`)
        throw new Error('getFileUploadURL GET data missing')
      }
    }
    catch (err) {
      throw this.handleError(err, 'Portal getFileUploadURL')
    }
  }

  getFileDownloadURL = async (filename, contentDisposition) => {
    try {
      const noParensFileName = filename.replace(/\(/g, '%28').replace(/\)/g, '%29')
      let url = `/portal/file/download/signed-url/${noParensFileName}`
      if (contentDisposition) {
        url += `?ContentDisposition=${contentDisposition}`
      }
      const res = await API.get('portalCompany', url, {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.downloadURL) {
        return res.data.downloadURL
      } else {
        console.error(`getFileDownloadURL GET data missing: ${JSON.stringify(res, null, 2)}`)
        throw new Error('getFileDownloadURL GET data missing')
      }
    }
    catch (err) {
      throw this.handleError(err, 'getFileDownloadURL')
    }
  }


  getFileListUpload = async () => {
    try {
      const res = await API.get('portalCompany', `/portal/file/upload`, {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.uploadFileList) {
        return res.data.uploadFileList
      }
      console.error(`Portal getFileListUpload GET data missing: ${JSON.stringify(res, null, 2)}`)
      throw new Error('Portal getFileListUpload GET data missing')
    }
    catch (err) {
      throw this.handleError(err, 'Portal getFileDownloadURL')
    }
  }

  delFileUploadFile = async (filename) => {
    try {
      const noParensFileName = filename.replace(/\(/g, '%28').replace(/\)/g, '%29')
      await API.del('portalCompany', `/portal/file/object/${noParensFileName}`, {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
    }
    catch (err) {
      throw this.handleError(err, 'delUploadFile')
    }
  }

  getMessages = async (sofId) => {
    try {
      const res = await API.get('portalCompany', `/portal/message/company/${sofId}`, {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.messages) {
        return res.data.messages
      }
      console.error(`Portal getMessages GET data missing: ${JSON.stringify(res, null, 2)}`)
      throw new Error('Portal getMessages GET data missing')
    }
    catch (err) {
      throw this.handleError(err, 'Portal getMessages')
    }
  }

  getRecentMessages = async () => {
    try {
      const res = await API.get('portalCompany', `/portal/recent-message/company`, {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.messages) {
        return res.data.messages
      }
      console.error(`Portal getRecentMessages GET data missing: ${JSON.stringify(res, null, 2)}`)
      throw new Error('Portal getRecentMessages GET data missing')
    }
    catch (err) {
      throw this.handleError(err, 'Portal getRecentMessages')
    }
  }

  getMessagesAsSOF = async () => {
    try {
      const res = await API.get('portalCompany', `/portal/message/sof`, {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.messages) {
        return res.data.messages
      }
      console.error(`Portal getMessagesAsSOF GET data missing: ${JSON.stringify(res, null, 2)}`)
      throw new Error('Portal getMessagesAsSOF GET data missing')
    }
    catch (err) {
      throw this.handleError(err, 'Portal getMessagesAsSOF')
    }
  }

  postMessage = async (sofId, message) => {
    try {
      await API.post('portalCompany', `/portal/message/company/object/${sofId}`, {
          body: {
            message
          },
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
    }
    catch (err) {
      throw this.handleError(err, 'Portal postMessage')
    }
  }

  postMessageAsSOF = async (companyId, message) => {
    try {
      await API.post('portalCompany', `/portal/message/sof/object/${companyId}`, {
          body: {
            message
          },
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
    }
    catch (err) {
      throw this.handleError(err, 'Portal postMessageAsSOF')
    }
  }

  putCriteria = async (criteria) => {
    try {
      await API.put('portalSearch', '/portal/criteria/company/object', {
          body: {
            criteria
          },
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
    }
    catch (err) {
      throw this.handleError(err, 'PortalCompany putCriteria')
    }
  }

  getCriteria = async () => {
    try {
      const res = await API.get('portalSearch', `/portal/criteria/company/object`, {
          response: true,
          headers: {
            Accept: 'application/json',
        }
      })
      if (res && res.data) {
        return res.data.criteria || {}
      }
      console.error(`PortalCompany getCriteria GET data missing: ${JSON.stringify(res, null, 2)}`)
      throw new Error('PortalCompany getCriteria GET data missing')
    }
    catch (err) {
      throw this.handleError(err, 'PortalCompany getCriteria')
    }
  }

  getSearchSOF = async (queryString, size, from) => {
    try {
      const sizeOpt = size ? `&size=${size}` : ''
      const fromOpt = from ? `&from=${from}` : ''
      const res = await API.get('portalSearch', `/portal/search/sof/object?query=${queryString}${sizeOpt}${fromOpt}`, {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.search) {
        return res.data.search
      } else {
        console.error(`Portal getSearchSOF GET getSearchSOF data missing: ${JSON.stringify(res, null, 2)}`)
        throw new Error('Portal getSearchSOF GET getSearchSOF data missing')
      }
    }
    catch (err) {
      throw this.handleError(err, 'Portal getSearchSOF')
    }
  }

  getSearchSOFCSV = async (queryString, size, from) => {
    try {
      const sizeOpt = size ? `&size=${size}` : ''
      const fromOpt = from ? `&from=${from}` : ''
      const res = await API.get('portalSearch', `/portal/csv/sof/object?query=${queryString}${sizeOpt}${fromOpt}`, {
        response: true,
        headers: {
          Accept: 'application/json',
        }
      })
      if (res && res.data && res.data.csv) {
        return res.data.csv
      } else {
        console.error(`Portal getSearchSOFCSV GET getSearchSOFCSV data missing: ${JSON.stringify(res, null, 2)}`)
        throw new Error('Portal getSearchSOFCSV GET getSearchSOFCSV data missing')
      }
    }
    catch (err) {
      throw this.handleError(err, 'Portal getSearchSOFCSV')
    }
  }


  retrieveContent() {
    return this.getContent()
  }

  retrieveContentSample() {
    return this.getContentSample()
  }

  storeContent(content) {
    return this.putContent(content)
  }

  publishContent() {
    return this.putPublishContent()
  }

  retrieveFileUploadURL(fileName, options) {
    return this.getFileUploadURL(fileName, options)
  }

  retrieveFileDownloadURL(fileName, contentDisposition) {
    return this.getFileDownloadURL(fileName, contentDisposition)
  }

  listFileUpload() {
    return this.getFileListUpload()
  }

  removeFileUploadFile(fileName) {
    return this.delFileUploadFile(fileName)
  }

  retrieveMessages(sofId) {
    return this.getMessages(sofId)
  }

  retrieveRecentMessages() {
    return this.getRecentMessages()
  }

  retrieveMessagesAsSOF() {
      return this.getMessagesAsSOF()
  }

  sendMessage(sofId, message) {
    return this.postMessage(sofId, message)
  }

  sendMessageAsSOF(companyId, message) {
    return this.postMessageAsSOF(companyId, message)
  }

  storeCriteria(criteria) {
    return this.putCriteria(criteria)
  }

  retrieveCriteria() {
    return this.getCriteria()
  }

  searchSOF(queryString, size, from) {
    return this.getSearchSOF(queryString, size, from)
  }

  searchSOFCSV(queryString, size, from) {
    return this.getSearchSOFCSV(queryString, size, from)
  }

}

export default PortalDataStoreAWS